export default "__VITE_ASSET__1b2b1230__"